import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=7efdd34a&"
import script from "./AdditionalInfo.vue?vue&type=script&lang=ts&"
export * from "./AdditionalInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports